module.exports = __webpack_public_path__ + "assets/img/preview_04.6494a4bc.png";